module.exports = __webpack_public_path__ + "static/media/background.48126b2c.png";